import { SandboxHistoryJsonModel } from '../../domain/stream/transaction/TransactionDomains';
import { SandboxActions } from '../actions/SandboxActions';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import moment from 'moment';

export interface SandboxState {
  histories: SandboxHistoryJsonModel | undefined;
  historyDate: string | undefined;
}

const initialState: SandboxState = {
  histories: undefined,
  historyDate: moment().subtract(4, 'year').toISOString(),
};

export const sandboxReducer = (state: SandboxState = initialState, action: ReduxBaseAction<any, SandboxActions>): SandboxState => {
  switch (action.type) {
    case 'SET_HISTORIES': {
      return {
        ...state,
        histories: action.payload,
      };
    }
    case 'CLEAR_HISTORIES':
      return {
        ...state,
        historyDate: moment().subtract(4, 'year').toISOString(),
        histories: undefined,
      };
    case 'SET_HISTORY_DATE':
      return {
        ...state,
        historyDate: action.payload,
      };
    default:
      return state;
  }
};
